export default "__VITE_ASSET__DkeyjGSt__"